import { Box, Typography } from "@mui/material";
import MapDigitalTwinFilters from "./MapDigitalTwinFilters";
import { useEffect, useState } from "react";
import { getPagesMetaData } from "../../../Api/Api";
import { fetchFiltersDataObject } from "../../../Helper/Table/TableHelper";
import { QuickFilterBox } from "./StyledComponents";
import { BATTERY_STATUS_MAP } from "../../../Helper/DigitalTwin/DataFile";

const MapFiltersSelection = ({
  selectedFilters,
  onApplyFilters,
  searchResultCount,
  container,
}) => {
  const [filters, setFilters] = useState({});
  const [highlightQuickFilters, setHighlightQuickFilters] = useState({});

  const handleFiltersSelection = (filters) => {
    onApplyFilters(filters);
  };

  function handleQuickFilter(value) {
    const updatedFilters = { ...selectedFilters };

    // ensure batteryStatus array exists
    if (!Array.isArray(updatedFilters.batteryStatus)) {
      updatedFilters.batteryStatus = [];
    }

    if (updatedFilters.batteryStatus.includes(value)) {
      // remove it
      updatedFilters.batteryStatus = updatedFilters.batteryStatus.filter(
        (v) => v !== value
      );
      // if empty, remove the key
      if (updatedFilters.batteryStatus.length === 0) {
        delete updatedFilters.batteryStatus;
      }
    } else {
      // add it
      updatedFilters.batteryStatus = [...updatedFilters.batteryStatus, value];
    }
    onApplyFilters(updatedFilters);
  }

  const fetchFiltersData = async () => {
    const pageName = "Inventory";
    const pagesMetaDataResponse = await getPagesMetaData(pageName);
    const pagesContent = pagesMetaDataResponse?.response?.response?.metaInfo;
    const digitalTwinTableFilters =
      pagesContent?.filterConfigurations?.digitalTwinListTable?.filters;
    if (!digitalTwinTableFilters) {
      return false;
    }

    const tabvalue = 0;
    const tabFilters = digitalTwinTableFilters.filter((filter, index) => {
      if (!filter.tabs) {
        return true;
      }
      return filter.tabs.includes(tabvalue);
    });

    const filtersObj = await fetchFiltersDataObject(tabFilters, filters);

    const sortedFiltersObj = Object.fromEntries(
      Object.entries(filtersObj).sort(([, a], [, b]) =>
        a.label.localeCompare(b.label)
      )
    );

    setFilters(sortedFiltersObj);
  };

  useEffect(() => {
    fetchFiltersData();
  }, []);

  useEffect(() => {
    if (selectedFilters?.batteryStatus) {
      setHighlightQuickFilters({
        charging: (selectedFilters?.batteryStatus || []).includes(BATTERY_STATUS_MAP.CHARGING),
        discharging: (selectedFilters?.batteryStatus || []).includes(BATTERY_STATUS_MAP.DISCHARGING),
        idle: (selectedFilters?.batteryStatus || []).includes(BATTERY_STATUS_MAP.IDLE),
      });
    } else {
      setHighlightQuickFilters({
        charging: false,
        discharging: false,
        idle: false,
      });
    }
  }, [selectedFilters]);

  return (
    <Box
      sx={{
        top: "16px",
        left: "16px",
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <MapDigitalTwinFilters
          filters={filters}
          selectedFilters={selectedFilters}
          setSelectedFilters={handleFiltersSelection}
          container={container}
        />
        <QuickFilterBox
          highlighted={highlightQuickFilters?.idle}
          onClick={() => handleQuickFilter(BATTERY_STATUS_MAP.IDLE)}
        >
          <Typography
            variant="fw400s12c3D4B5A"
            sx={{
              lineHeight: "16px",
              color: highlightQuickFilters?.idle ? "#6D72F6" : "#3D4B5A",
              fontWeight: highlightQuickFilters?.idle ? 500 : 400,
            }}
          >
            Idle
          </Typography>
        </QuickFilterBox>
        <QuickFilterBox
          highlighted={highlightQuickFilters?.discharging}
          onClick={() => handleQuickFilter(BATTERY_STATUS_MAP.DISCHARGING)}
        >
          <Typography
            variant="fw400s12c3D4B5A"
            sx={{
              lineHeight: "16px",
              color: highlightQuickFilters?.discharging ? "#6D72F6" : "#3D4B5A",
              fontWeight: highlightQuickFilters?.discharging ? 500 : 400,
            }}
          >
            Discharging
          </Typography>
        </QuickFilterBox>
        <QuickFilterBox
          highlighted={highlightQuickFilters?.charging}
          onClick={() => handleQuickFilter(BATTERY_STATUS_MAP.CHARGING)}
        >
          <Typography
            variant="fw400s12c3D4B5A"
            sx={{
              lineHeight: "16px",
              color: highlightQuickFilters?.charging ? "#6D72F6" : "#3D4B5A",
              fontWeight: highlightQuickFilters?.charging ? 500 : 400,
            }}
          >
            Charging
          </Typography>
        </QuickFilterBox>
      </Box>
      {Object.keys(selectedFilters).length > 0 && (
        <Box>
          <Box
            sx={{
              boxShadow: "2px 2px 4px 0px rgba(151, 151, 151, 0.25)",
              backgroundColor: "#494949",
              borderRadius: "16px",
              padding: "8px 12px",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="fw500s12c000"
              sx={{ color: "#FAFAFA", lineHeight: "16px" }}
            >
              {searchResultCount}&nbsp;
              {searchResultCount === 1 ? "Result" : "Results"}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MapFiltersSelection;
